export interface CmsProtectionCardBanner {
  protectionCardBannerPlan: string;
  protectionCardBannerRegistration: string;
}
